import React from 'react';
import { GraduationCap, PlayCircle, FileText, ExternalLink } from 'lucide-react';

const AULAS_URL = 'https://shoficina.com.br/site/aulas.php';

export const VideoAulasSection = () => (
  <article className="mb-16 bg-gradient-to-br from-blue-900/20 via-slate-800/60 to-slate-900 border border-blue-500/20 rounded-2xl p-8 overflow-hidden relative"
    aria-labelledby="video-aulas-title" data-testid="shoficina-video-aulas">
    <div className="absolute -top-20 -right-20 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center relative z-10">
      <div>
        <span className="inline-flex items-center gap-1.5 bg-blue-500/15 text-blue-400 text-xs font-semibold px-3 py-1 rounded-full mb-3">
          <GraduationCap className="w-3.5 h-3.5" /> Plataforma de Aprendizado
        </span>
        <h3 id="video-aulas-title" className="text-2xl md:text-3xl font-bold text-white mb-3">
          Você não precisa ser <span className="text-blue-400">expert</span>
        </h3>
        <p className="text-slate-400 text-sm mb-6">
          O SHOficina foi criado pensando na facilidade. Além de intuitivo, você conta com uma plataforma completa de aprendizado para dominar cada função do sistema.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
          <div className="bg-slate-900/50 border border-slate-700/50 rounded-xl p-4">
            <PlayCircle className="w-6 h-6 text-red-400 mb-2" />
            <p className="text-white font-semibold text-sm mb-1">Vídeo Aulas</p>
            <p className="text-slate-500 text-xs">Tutoriais passo a passo para cada função do sistema.</p>
          </div>
          <div className="bg-slate-900/50 border border-slate-700/50 rounded-xl p-4">
            <FileText className="w-6 h-6 text-cyan-400 mb-2" />
            <p className="text-white font-semibold text-sm mb-1">Manuais PDF</p>
            <p className="text-slate-500 text-xs">Guias ilustrados para consulta rápida quando precisar.</p>
          </div>
        </div>
        <a href={AULAS_URL} target="_blank" rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 text-white font-bold px-6 py-3 rounded-xl text-sm shadow-lg shadow-blue-500/20 transition-all hover:-translate-y-0.5"
          data-testid="acessar-aulas-btn" aria-label="Acessar vídeo aulas do SHOficina">
          <GraduationCap className="w-4 h-4" /> Acessar Aulas <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </div>
      <div className="flex justify-center">
        <img
          src="./img/shoficina/video-aulas.png"
          alt="Vídeo aulas do sistema para oficina mecânica SHOficina"
          className="w-full max-w-md h-auto rounded-xl shadow-2xl shadow-blue-500/10"
          loading="lazy"
        />
      </div>
    </div>
  </article>
);

export default VideoAulasSection;
